<p>
  pia3-register compoenent works!
</p>
